export default __webpack_public_path__ + "d25ce19da5c389dd4b1e93b1b901741b.png";